// extracted by mini-css-extract-plugin
export default {"cls1":"SplitMobileFab-SecondOption_cls1__j9BUk","cls2":"SplitMobileFab-SecondOption_cls2__-P3QQ SplitMobileFab-SecondOption_cls1__j9BUk"};